module.exports = __webpack_public_path__ + "static/media/293.bb211950.jpg";